import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  ASSET,
  BANNER_BLOCK,
  FACTS_BLOCK,
  GIF,
  ONWARDS_5050_BLOCK,
  PRODUCT_CAROUSEL_BLOCK,
  QUOTE_CAROUSEL_BLOCK,
  RICH_TEXT,
  SEO,
  TEAM_BLOCK,
} from 'lib/queries';
import { TIMELINE_BLOCK } from 'lib/queries/blocks/timeline';
import { client } from 'lib/sanity';
import type { AboutPage } from 'types/cms/pages/AboutPage';

type AboutPageQuery = UseQueryResult & {
  data: AboutPage;
};

export const ABOUT_KEY = 'aboutPage';

export const fetchAboutPage = async () => {
  const query = groq`
    *[_type in['timeline_about'] && _id == "about" && !(_id in path('drafts.**'))][0] {
      ${SEO},
      hero {
        title,
        heroMedia[] {
          _type,
          ${ASSET},
          desktop {
            ${GIF}
          },
          mobile {
            ${GIF}
          }
        },
        heroVideoUrl,
      },
      mission {
        title,
        description[] {
          ${RICH_TEXT}
        }
      },
      sections[] {
        _key,
        _ref,
        _type,
        ${QUOTE_CAROUSEL_BLOCK},
        ${FACTS_BLOCK},
        ${TEAM_BLOCK},
        ${BANNER_BLOCK},
        ${ONWARDS_5050_BLOCK},
        ${TIMELINE_BLOCK},
        ${PRODUCT_CAROUSEL_BLOCK}
      }
    }
  `;

  const about: AboutPage = await client.fetch(query);

  return about;
};

export const useAbout = () =>
  useQuery({
    queryKey: [ABOUT_KEY],
    queryFn: fetchAboutPage,
  }) as AboutPageQuery;
